import styles from "styles/components/circle.module.scss";

const Circle = ({ color }) => (
  <div className={styles.circle} style={{ background: color }} />
);

export default Circle;
